import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import Modal from "react-modal"
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

import { css } from "@emotion/react"
import { rgba } from "polished"

import modalStyle from "../modal-style"
import useMixins, { globalColors } from "../css-functions"
import Image from "../image"

import SvgCloseButton from "../../assets/svg/x.svg"

import ArchivesContent from "./contents/archivescontent"
import OthersContent from "./contents/otherscontent"

const WorksExhibitions = ({
  pcTitle,
}) => {
  const [ modalIsOpen, setIsOpen ] = useState({archives: false, others: false})
  const [ targetModalElement, setModalElement ] = useState(null)

  const mixins = useMixins()

  const handleModal = {
    open: target => {
      setIsOpen({...modalIsOpen, [ target ]: true})
    },
    close: target => {
      setIsOpen({...modalIsOpen, [ target ]: false})
    },
  }

  const overriddenModalStyle = modalStyle({
  }, {
    padding: "60px 8px",
  })

  useEffect(() => {
    if ( targetModalElement !== null ) {
      modalIsOpen ? disableBodyScroll(targetModalElement) : enableBodyScroll(targetModalElement)
    }

    return () => clearAllBodyScrollLocks()
  }, [ modalIsOpen, targetModalElement ])

  const style = {
    section: css`
      ${ mixins.default.sectionStyle }
    `,
    title: css`
      ${ mixins.default.generalTitleStyle }
    `,
    content: css`
      ${ mixins.default.contentStyle }
    `,
    text: css`
      ${ mixins.default.textStyle }
    `,
    buttonWrapper: css`
      margin-top: 32px;
    `,
    detailButton: css`
      ${ mixins.default.goDetailButtonStyle }
    `,
    close: css`
      width: 32px;
      height: 32px;
      position: fixed;
      top: 16px;
      right: 16px;
      background-color: ${ rgba(globalColors.white, 0.8) };
      border-radius: 20px;
      box-shadow: 0 0 10px ${ rgba(globalColors.black, 0.2) };
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
    `,
  }

  return (
    <>
      { pcTitle }
      <section css={style.section}>
        <h2 css={style.title}>盆石展</h2>
        <div css={style.content}>
          <p css={style.text}>　一般財団法人細川流盆石が主催しました展覧会の記録です。</p>
          <div>
            <Image filename="works_img6.png" />
          </div>
          <div css={style.buttonWrapper}>
            <button
              onClick={() => handleModal.open("archives")}
              type="button"
              css={style.detailButton}
            >
              過去の盆石展はこちら
            </button>
          </div>
          <Modal
            contentRef={ node => setModalElement(node) }
            isOpen={modalIsOpen.archives}
            onRequestClose={() => handleModal.close("archives")}
            shouldCloseOnOverlayClick={true}
            closeTimeoutMS={200}
            style={overriddenModalStyle}
          >
            <button
              onClick={() => handleModal.close("archives")}
              css={style.close}
            >
              <SvgCloseButton />
            </button>
            <ArchivesContent />
          </Modal>
        </div>
      </section>
      <section css={style.section}>
        <h2 css={style.title}>その他活動</h2>
        <div css={style.content}>
          <p css={style.text}>xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx</p>
          <div>
            <Image filename="works_img6.png" />
          </div>
          <div css={style.buttonWrapper}>
            <button
              onClick={() => handleModal.open("others")}
              type="button"
              css={style.detailButton}
            >
              詳細はこちら
            </button>
          </div>
          <Modal
            contentRef={ node => setModalElement(node) }
            isOpen={modalIsOpen.others}
            onRequestClose={() => handleModal.close("others")}
            shouldCloseOnOverlayClick={true}
            closeTimeoutMS={200}
            style={overriddenModalStyle}
          >
            <button
              onClick={() => handleModal.close("others")}
              css={style.close}
            >
              <SvgCloseButton />
            </button>
            <OthersContent />
          </Modal>
        </div>
      </section>
    </>
  )
}

WorksExhibitions.propTypes = {
  pcTitle: PropTypes.object,
}

export default WorksExhibitions